import {
  Tabs,
  WhiteSpace,
  List,
  Button,
  Modal,
  Switch,
  InputItem,
  Picker,
  Toast,
  Drawer,
} from "antd-mobile-v2";
import "./index.less";
import React, { Component } from "react";
import allUrl from "../../api/allUrl";
import { post, get, postRaw } from "../../api/service/services";
import tool from "../../api/tool";
import secsstion from "../../api/service/secsstion";
import { createForm } from "rc-form";
import RelatedComt from "../../components/Related";
import SentsitiveCont from "../../components/Sensitive";
import { GenderData, formInputData, childrenVal } from "./const";
import Preview from "./preview";
const Item = List.Item;
let errorDataObj = {};
let submitData = {};
let isData = ["hasPosition", "isAccept", "isArbitrate", "isPublic", "isReview"];
class SloveThings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 60,
      flagCode: true,
      pathName: "",
      cityData: [],
      leibieData: [],
      drawerOpen: false,
      senFilter: {},
      modal: false,
      fadIn: "",
      open: false,
    };
  }
  // 获取省市县数据
  getData = () => {
    post(
      allUrl.register.getRegnData,
      {},
      {
        "Content-Type": "application/json;charset=UTF-8",
      }
    )
      .then((res) => {
        if (res.success === true && res.code == 200) {
          let data = JSON.parse(res.data) || [];
          let newData = childrenVal(data, ["code", "name"]);
          tool.set("cityData", newData);
          this.setState({ cityData: newData });
        } else {
        }
      })
      .catch((error) => {});
  };
  // 获取问题类别数据
  getCategoryData = () => {
    postRaw(
      allUrl.register.getCategory,
      {
        code: "wentixingzhi",
      },
      {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    ).then((res) => {
      if (res.success === true && res.code == 200) {
        try {
          let data = JSON.parse(res.data);
          let newData = childrenVal(data, ["dicCode", "dicName"]);
          this.setState({ leibieData: newData });
        } catch (error) {
          console.log(error);
        }
      } else {
        Toast.info(res.msg, 1);
      }
    });
  };
  // 获取验证码
  catchapCode = () => {
    const { flagCode } = this.state;
    let phoneS = this.props.form.getFieldValue("phoneNumber");
    if (!phoneS) {
      Toast.fail("请输入手机号", 1);
      return;
    }
    if (!flagCode) {
      return;
    }
  };
  // 下一步之前数据提交
  onSubmit = () => {
    this.props.form.validateFields((error, values) => {
      if (error) {
        let errorData = Object.keys(error)[0];
        Toast.info(error[errorData].errors[0].message, 1);
        return;
      }
      let isFlag = Object.keys(this.state.senFilter).filter((item) => {
        return this.state.senFilter[item] !== "";
      });
      if (isFlag.length > 0) {
        let errorText = this.state.senFilter[isFlag[0]];
        if (errorText === "内容包含敏感词") {
          this.ReplyDubmit(values, { type: true });
        }
        Toast.info("填报内容包含敏感词无法提交", 1);
        return;
      }
      this.ReplyDubmit(values, { type: false });
    });
  };
  ReplyDubmit = (dataVal, isType) => {
    this.createEditData(dataVal, isType);
  };
  // 处理数据然后进行预览展示汉字
  createEditData = (values, isType) => {
    tool.set("submitData", values);
    if (isType.type) {
      this.succeSubMitData();
      return;
    }
    this.setState({ modal: true });
  };
  // 根据key过滤率label
  filterCityName = (val, cityData, newData) => {
    for (var i = 0; i < cityData.length; i++) {
      if (cityData[i].value == val) {
        newData.push(cityData[i].label);
      } else {
        if (cityData[i].children && cityData[i].children.length > 0) {
          this.filterCityName(val, cityData[i].children, newData);
        }
      }
    }
    return newData;
  };

  // 密码和确认密码
  compareToFirstPassword = (rule, value, callback) => {
    if (value && value !== this.props.form.getFieldValue("userPassword")) {
      callback("您输入的密码不一致");
    } else {
      callback();
    }
  };
  componentDidMount() {
    this.getData();
    this.getCategoryData();
    const { location } = this.props;
    this.setState({
      pathName: location.pathname,
    });
  }
  // 涉事单位选中时触发
  selectData = (data) => {
    const { setFieldsValue } = this.props.form;
    submitData.selectData = data;
    setFieldsValue({ complaintOrgCode: data.label });
    this.setState({ open: false });
  };
  // 抽屉点击取消时触发的事件
  drawonCancel = () => {
    this.setState({ open: false });
  };
  // 主要观点输入框离开赋值敏感词过滤
  changeBlur = (vals) => {
    console.log("输入框离开的时候进行处罚");
    this.reSetvalue(vals, "mainAppeal");
  };
  // 事实和理由输入框离开赋值敏感词过滤
  shichangeBlur = (vals) => {
    this.reSetvalue(vals, "complaintReason");
  };
  reSetvalue = (vals, label) => {
    let tvlp = vals.val.replace(/<[^>]+>/gi, "");
    errorDataObj[label] = tvlp;
    if (vals.flag) {
      let obj = {
        ...this.state.senFilter,
        [label]: vals.err ? "敏感词过滤异常" : "内容包含敏感词",
      };
      this.setState({ senFilter: obj });
      this.props.form.setFields({
        [label]: {
          value: vals.val != "" ? vals.val : "",
          errors: [new Error(vals.err ? "敏感词过滤异常" : "内容包含敏感词")],
        },
      });
    } else {
      let obj = { ...this.state.senFilter, [label]: "" };
      this.setState({ senFilter: obj });
      this.props.form.setFields({
        [label]: {
          value: vals.val != "" ? vals.val : "",
          success: [],
        },
      });
    }
  };
  onWrapTouchStart = (e) => {
    // fix touch to scroll background page on iOS
    if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
      return;
    }
    const pNode = this.closest(e.target, ".am-modal-content");
    if (!pNode) {
      e.preventDefault();
    }
  };
  closest(el, selector) {
    const matchesSelector =
      el.matches ||
      el.webkitMatchesSelector ||
      el.mozMatchesSelector ||
      el.msMatchesSelector;
    while (el) {
      if (matchesSelector.call(el, selector)) {
        return el;
      }
      el = el.parentElement;
    }
    return null;
  }
  // 确定开始提交数据
  succeSubMitData = () => {
    try {
      let applyType =
        this.props.location &&
        this.props.location.state &&
        this.props.location.state.comiplatType
          ? this.props.location.state.comiplatType
          : "";
      let newData = {};
      let values = tool.get("submitData"); // 用户填写数据
      const asscateData = tool.get("asscateData") || []; // 联名人数据
      values["sheshi"] = submitData.selectData;
      if (Number(submitData.selectData.orgDet) > 1) {
        values["complaintParentOrg"] = submitData.selectData.value;
        values["complaintOrgCode"] = "";
      } else {
        values["complaintParentOrg"] = submitData.selectData.parentOrgId;
      }
      isData.forEach((item) => {
        values[item] =  "02";
      });
      let isFlag = Object.keys(this.state.senFilter).filter((item) => {
        return this.state.senFilter[item] !== "";
      });
      values["complaintTypeValue"] = "意见建议";
      values["complaintType"] = "1901";
      values["isPublic"] = "02";
      values["AssociateData"] = asscateData;
      values["mainAppeal"] = errorDataObj["mainAppeal"];
      values["complaintReason"] = errorDataObj["complaintReason"];

      values["uniteCount"] = asscateData.length;
      newData["pcComplaintJoint"] = values.AssociateData;
      newData["pcComplaintDetail"] = values;
      newData["applyType"] = '04';
      newData["approvalStatus"] = "00";
      newData["dataSource"] = "01";
      newData["applyUserCode"] = secsstion.get("acount")
        ? secsstion.get("acount")
        : "";
      newData["applyUserName"] = secsstion.get("nick_name")
        ? secsstion.get("nick_name")
        : ""; // 后期修改
      newData["createDept"] = secsstion.get("qiOrgCode") // 后期修改
      if (isFlag.length > 0) {
        let errorText = this.state.senFilter[isFlag[0]];
        if (errorText === "内容包含敏感词") {
          newData["approvalStatus"] = "01";
          Toast.info("填报内容包含敏感词无法提交", 2, () => {
            this.requestSumitData({
              ...newData,
              refuseReason: "提交内容存敏感词",
            });
          });
        }
        return;
      }
      this.requestSumitData(newData);
    } catch (error) {}
  };
  requestSumitData = (data) => {
    post(allUrl.register.saveData, data, {
      "Content-Type": "application/json;charset=UTF-8",
    })
      .then((res) => {
        if (res.success === true && res.code == 200) {
          if (data.refuseReason) return;
          this.setState({ modal: false });
          this.props.history.push({
            pathname: "/success",
            state: {
              subMiTitle: "意见建议",
            },
          });
        } else {
          Toast.info(res.msg, 1);
        }
      })
      .catch((error) => {
        Toast.info("提交失败", 1);
      });
  };
  render() {
    const { getFieldProps, getFieldError, resetFields } = this.props.form;
    const { count, flagCode, drawerOpen } = this.state;
    const asscateData = tool.get("asscateData") || [];
    const cententData = tool.get("formData");
    return (
      <div className="slove-wrap">
        <Modal
          visible={this.state.modal}
          transparent
          className="preview-modal"
          maskClosable={false}
          title="预览"
          footer={[
            {
              text: "取消",
              onPress: () => {
                this.setState({ modal: false });
              },
            },
            {
              text: "确定提交",
              onPress: () => {
                this.succeSubMitData();
              },
            },
          ]}
          wrapProps={{ onTouchStart: this.onWrapTouchStart }}
        >
          <Preview />
        </Modal>
        <div
          className={`draw-cont ${this.state.fadIn}`}
          style={{ display: this.state.open ? "block" : "none" }}
        >
          <RelatedComt
            selectData={this.selectData}
            drawonCancel={this.drawonCancel}
            placeholder="请输入涉及单位名称关键字"
          />
        </div>

        <form>
          <List style={{ paddingTop: "0.5rem" }}>
            <InputItem
              {...getFieldProps("complaintOrgCode", {
                initialValue:
                  cententData && cententData.complaintOrgCode
                    ? cententData.complaintOrgCode
                    : "",
                rules: [
                  { required: true, message: "请输入涉及单位名称关键字" },
                ],
              })}
              clear
              error={!!getFieldError("complaintOrgCode")}
              onFocus={() => {
                document.body.style.overflow = "hidden";
                this.setState({ open: true, fadIn: "fadein" });
              }}
              editable={false}
              placeholder="请输入涉及单位名称关键字"
              labelNumber={8}
              maxLength={50}
            >
              <span style={{ color: "red" }}>*</span> 涉及单位
            </InputItem>
            <div className="textAre-title">
              <span style={{ color: "red" }}>*</span> 主要观点
            </div>
            <div
              {...getFieldProps("mainAppeal", {
                initialValue:
                  cententData && cententData.mainAppeal
                    ? cententData.mainAppeal
                    : "",
                rules: [{ required: true, message: "请输入主要观点" }],
              })}
              style={{ padding: "0 0.15rem" }}
            >
              <SentsitiveCont
                blurData={this.changeBlur}
                placelder="请输入主要观点，500字以内"
                styles={{ height: "2rem" }}
                maxCount={500}
                id="appleCont"
                initVal={
                  cententData && cententData.mainAppeal
                    ? cententData.mainAppeal
                    : ""
                }
              />
            </div>
            <div className="textAre-title">
              <span style={{ color: "red" }}>*</span>具体建议
            </div>
            <div
              {...getFieldProps("complaintReason", {
                initialValue:
                  cententData && cententData.complaintReason
                    ? cententData.complaintReason
                    : "",
                rules: [{ required: true, message: "请输入具体建议" }],
              })}
              style={{ padding: "0 0.15rem" }}
            >
              <SentsitiveCont
                blurData={this.shichangeBlur}
                placelder="请输入具体建议，900字以内"
                styles={{ height: "3rem" }}
                maxCount={900}
                id="shileCont"
                initVal={
                  cententData && cententData.complaintReason
                    ? cententData.complaintReason
                    : ""
                }
              />
            </div>
          </List>
          <Item>
            <div className="footer-btn">
              <Button type="primary" inline onClick={this.onSubmit}>
                预览
              </Button>
              <Button
                type="ghost"
                inline
                onClick={() => {
                  this.props.history.goBack();
                }}
              >
                取消
              </Button>
            </div>
          </Item>
        </form>
      </div>
    );
  }
}
export default createForm()(SloveThings);
